/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Products_CompleteInputs */

const vi_import_products_complete = /** @type {(inputs: Import_Products_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import sản phẩm hoàn tất`)
};

/**

* @param {Import_Products_CompleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_products_complete = /** @type {((inputs?: Import_Products_CompleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Products_CompleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_products_complete(inputs)
});